import { render, staticRenderFns } from "./ReporteGerenciaDetallesPagos.vue?vue&type=template&id=a6b3ca98"
import script from "./ReporteGerenciaDetallesPagos.vue?vue&type=script&lang=js"
export * from "./ReporteGerenciaDetallesPagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports